export const webEndPoint = process.env.REACT_APP_API_URL;